import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

// Создаем стили
const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica', color: '#333' },
  header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 },
  title: { fontSize: 24, color: '#030213', fontWeight: 'bold' },
  infoSection: { marginBottom: 20 },
  infoText: { marginBottom: 2 },
  
  // Таблица
  table: { display: 'table', width: 'auto', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', marginBottom: 20 },
  tableRow: { flexDirection: 'row' },
  tableColHeader: { width: '20%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', backgroundColor: '#030213', color: '#fff', padding: 5 },
  tableColName: { width: '40%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', backgroundColor: '#030213', color: '#fff', padding: 5 },
  tableCell: { width: '20%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', padding: 5 },
  tableCellName: { width: '40%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', padding: 5 },
  
  // Итоги
  totals: { marginLeft: 'auto', width: '40%' },
  totalRow: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 3 },
  totalBold: { fontWeight: 'bold', fontSize: 12, borderTopWidth: 1, borderColor: '#333', marginTop: 5, paddingTop: 5 },
  footer: { position: 'absolute', bottom: 30, left: 30, right: 30, textAlign: 'center', color: '#999', fontSize: 8 }
});

const CatalogPageInvoiceTemplate = ({ cartItems, total, totalWithoutVAT, tradeName }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Шапка */}
      <View style={styles.header}>
        <View>
          <Text style={styles.title}>INVOICE</Text>
          <Text>Store: {tradeName}</Text>
        </View>
        <View style={{ textAlign: 'right' }}>
          <Text>Date: {new Date().toLocaleDateString()}</Text>
          <Text>Order: #MAK-{Math.floor(Math.random() * 10000)}</Text>
        </View>
      </View>

      {/* Инфо */}
      <View style={styles.infoSection}>
        <Text style={{ fontWeight: 'bold' }}>Seller:</Text>
        <Text style={styles.infoText}>Catalog Digital Delivery Services</Text>
        <Text style={styles.infoText}>VAT ID: ESB12345678</Text>
      </View>

      {/* Таблица */}
      <View style={styles.table}>
        {/* Заголовок таблицы */}
        <View style={styles.tableRow}>
          <View style={styles.tableColName}><Text>Product</Text></View>
          <View style={styles.tableColHeader}><Text>Price</Text></View>
          <View style={styles.tableColHeader}><Text>Qty</Text></View>
          <View style={styles.tableColHeader}><Text>Total</Text></View>
        </View>

        {/* Строки товаров */}
        {cartItems.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCellName}><Text>{item.name}</Text></View>
            <View style={styles.tableCell}><Text>€{item.spoPrice.toFixed(2)}</Text></View>
            <View style={styles.tableCell}><Text>{item.quantity}</Text></View>
            <View style={styles.tableCell}><Text>€{(item.spoPrice * item.quantity).toFixed(2)}</Text></View>
          </View>
        ))}
      </View>

      {/* Итоговая часть */}
      <View style={styles.totals}>
        <View style={styles.totalRow}>
          <Text>Net Value:</Text>
          <Text>€{totalWithoutVAT.toFixed(2)}</Text>
        </View>
        <View style={styles.totalRow}>
          <Text>VAT Amount:</Text>
          <Text>€{(total - totalWithoutVAT).toFixed(2)}</Text>
        </View>
        <View style={[styles.totalRow, styles.totalBold]}>
          <Text>TOTAL:</Text>
          <Text>€{total.toFixed(2)}</Text>
        </View>
      </View>

      <Text style={styles.footer}>Thank you for your business!</Text>
    </Page>
  </Document>
);

export default CatalogPageInvoiceTemplate;